//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region components
import AuditSheetDetailsView from "../widgets/auditSheetDetailsView";
import AuditSheetDialogTitle from "../widgets/auditSheetDialogTitle";
import AuditSheetNavigatedDetailsView from "../widgets/auditSheetNavigatedDetailsView";
import { AuditSheetNavigationProvider } from "./auditSheetNavigationContext";
import { findAuditSheetNavigationIndex } from "../widgets/auditSheetNavigation";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { AuditSheetNavigationItem } from "models/propTypes/accountingPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function useAuditSheetPreview() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const getAuditSheetPreviewDialog = (
    auditSheetId: number,
    auditSheetTitle: string,
    navigationItems?: AuditSheetNavigationItem[]
  ): DialogProps => {
    const dialog: DialogProps = {
      isOpen: false,
      title: auditSheetTitle,
      titleIcon: IconDefinitionConstants.WList,
      dialogType: DialogEnums.DialogType.Content,
      children: <AuditSheetDetailsView auditSheetId={auditSheetId} />,
      hideFooter: true,
      maxWidth: "md",
      fullWidth: true,
      // Full height for every sheet: whether it has files is only known after it loads, and the account
      // navigation would otherwise change the dialog's height between accounts.
      className: cssExports.dialogFullHeight,
    };

    const initialIndex = navigationItems ? findAuditSheetNavigationIndex(navigationItems, auditSheetId) : undefined;
    if (initialIndex === undefined) return dialog;

    return {
      ...dialog,
      title: <AuditSheetDialogTitle />,
      children: <AuditSheetNavigatedDetailsView />,
      contextProvider: AuditSheetNavigationProvider,
      contextProviderProps: { items: navigationItems, initialIndex },
    };
  };

  const showAuditSheetPreviewDialog = async (
    auditSheetId: number,
    auditSheetTitle: string,
    navigationItems?: AuditSheetNavigationItem[]
  ) => {
    dispatch(displayDialog(getAuditSheetPreviewDialog(auditSheetId, auditSheetTitle, navigationItems)));
  };

  return { showAuditSheetPreviewDialog, getAuditSheetPreviewDialog };
}

export default useAuditSheetPreview;
